

export class VehicleGroupStatusInput implements IVehicleGroupStatusInput {
    /** The auto-generated id of the vehicle group master */
    vehicleGroupId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IVehicleGroupStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleGroupId = _data["vehicleGroupId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): VehicleGroupStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleGroupStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleGroupId"] = this.vehicleGroupId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IVehicleGroupStatusInput {
    /** The auto-generated id of the vehicle group master */
    vehicleGroupId: number;
    /** The updated status */
    status: number;
}

